import { render, staticRenderFns } from "./ResultTermList.vue?vue&type=template&id=0d6da604"
import script from "./ResultTermList.vue?vue&type=script&lang=js"
export * from "./ResultTermList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_css-loader@6.11.0_webpack@5.110.3_clean-css_2613efb7275523429f28c1621a235b94/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports